import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './notification-bar.scss';

const NotificationBar = (props) => {
	const { type, redirect_message } = props;
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setVisible(false);
		}, 11000);

		return () => clearTimeout(timer);
	}, []);

	const classNames = `notification-bar notification-bar--${type}`;

	return (
		<>
			{visible &&
				createPortal(
					<div className={classNames}>
						<div className="notification-bar__inner">
							<p className="notification-bar__text">
								{redirect_message}
							</p>
						</div>
					</div>,
					document.body
				)}
		</>
	);
};

export default NotificationBar;
